import * as React from 'react';

function SvgComments(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 35.152 34.968" {...props}>
      <path
        data-name="Path 4108"
        d="M2.2 9.473h24.129v14.97H9.579l-5.321 5.22.075-5.22H2.2zM8.968 2.2h23.991v14.963h-4.433V7.276H8.968zM6.771 0v7.276H0v19.36h2.1l-.11 8.331 8.485-8.331h18.051V19.36h6.626V0z"
        fill="#eea804"
      />
    </svg>
  );
}

export default SvgComments;
